/** Split value/value_l1: API uses "," (e.g. Yes,No) and "،" (Arabic comma U+060C, e.g. نعم،لا). */
export const COMMA_SPLIT = /[,،]/;
